/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_Windows_Step2Inputs */

const en_gc_resources_download_windows_step2 = /** @type {(inputs: Gc_Resources_Download_Windows_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the installer and follow the setup prompts.`)
};

const zh_gc_resources_download_windows_step2 = /** @type {(inputs: Gc_Resources_Download_Windows_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开安装程序，按提示完成安装。`)
};

/**
* | output |
* | --- |
* | "Open the installer and follow the setup prompts." |
*
* @param {Gc_Resources_Download_Windows_Step2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_windows_step2 = /** @type {((inputs?: Gc_Resources_Download_Windows_Step2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_Windows_Step2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_windows_step2(inputs)
	return zh_gc_resources_download_windows_step2(inputs)
});
export { gc_resources_download_windows_step2 as "gc.resources.download.windows.step2" }